<p>fifo-expiry works!</p>
